module.exports = __webpack_public_path__ + "img/stupito.ffa57ef1.png";